import React from 'react';
import {observer} from 'mobx-react';
import {Grid} from '@mui/material';
import FormSection from '../../forms/FormSection';
import FormRow from '../../forms/FormRow';
import FormColumn from '../../forms/FormColumn';
import FormTextField from '../fields/FormTextField';
import GoogleAddressMap from '../maps/GoogleAddressMap';
import GoogleAddressMapFeature from '../maps/GoogleAddressMapFeature';
import useFeature from '../../useFeature';

function DeliverySiteFormScreen({deliverySite}) {
    const mapFeature = useFeature(() => new GoogleAddressMapFeature(
            deliverySite,
            'address',
            'jurisdiction',
            'city',
            'postalCode',
        ), [deliverySite]);

    return (
        <FormSection>
            <FormColumn>
                <FormRow>
                    <FormTextField
                        label="Nombre del Punto de Entrega"
                        form={deliverySite}
                        fieldName="name"
                    />
                    <FormTextField
                        label="Domicilio"
                        form={deliverySite}
                        fieldName="address"
                    />
                    <FormTextField
                        label="Provincia"
                        form={deliverySite}
                        fieldName="jurisdiction"
                    />
                </FormRow>
                <FormRow>
                    <FormTextField
                        label="Localidad"
                        form={deliverySite}
                        fieldName="city"
                    />
                    <FormTextField
                        label="Código Postal"
                        form={deliverySite}
                        fieldName="postalCode"
                    />
                </FormRow>
                <FormRow>
                    <Grid item xs={12}>
                        <GoogleAddressMap
                            feature={mapFeature}
                            form={deliverySite}
                            fieldName="address"
                        />
                    </Grid>
                </FormRow>
            </FormColumn>
        </FormSection>
    );
}

export default observer(DeliverySiteFormScreen);
